export default "__VITE_PUBLIC_ASSET__52f63d23__"